import { useFetch } from './useFetch';

interface LoggerResponse {
  message: string;
}

export type LoggerFunction = (body: {
  message: string;
  level: string;
  extra?: Record<string, unknown>;
}) => Promise<LoggerResponse | undefined>;

export function useLogger(): {
  logToNewRelic: LoggerFunction;
} {
  const { fetch: logToNewRelic } = useFetch<LoggerResponse>({
    url: '/api/logger',
    fetchOptions: { method: 'POST' },
    lazy: true,
  });

  return { logToNewRelic };
}
